// src/components/LogoutButton.tsx
import React from 'react';
import { IconButton, SxProps, Theme } from '@mui/material';
import { ExitToApp as ExitToAppIcon } from '@mui/icons-material';
import { useAuth } from '../../../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';

interface LogoutButtonProps {
  color?: string;
  hoverColor?: string;
  sx?: SxProps<Theme>;
}

const LogoutButton: React.FC<LogoutButtonProps> = ({ 
  color = 'inherit', 
  hoverColor,
  sx = {} 
}) => {
  const { signOut } = useAuth();
  const navigate = useNavigate();
  
  const handleLogout = async () => {
    try {
      await signOut();
      // Navigate to the login page (or landing page) after successful logout
      navigate('/login', { replace: true });
    } catch (err) {
      console.error('Logout error:', err);
      // Optionally: display an error message to the user
    }
  };

  return (
    <IconButton 
      aria-label="logout" 
      onClick={handleLogout}
      sx={{ 
        color,
        '&:hover': {
          color: hoverColor,
        },
        ...sx
      }}
    >
      <ExitToAppIcon />
    </IconButton>
  );
};

export default LogoutButton;